import { useEffect, useState } from "react"

import { useScenario} from "../../contexts/ScenarioContext"

import RevealTable from "../RevealTable"

const VitalsTabContent = () => {
    const { currentVitals } = useScenario()

    const calcVitalsRows = () => Object.entries(currentVitals).map(([key, val]) => ({ label: key, value: val }))

    const [vitalsRows, setVitalsRows] = useState(calcVitalsRows())

    useEffect(
        () => {
            const newVal = calcVitalsRows()
            if (newVal !== vitalsRows) {
                setVitalsRows(newVal)
            }
        }, [currentVitals]
    )

    return (
            <RevealTable
                title="Vitals"
                category="vitals"
                headings={["Vital", "Current Value"]}
                rows={vitalsRows}
            />
    )
}

export default VitalsTabContent